export interface ResourceItem {
  categoryName: string;
  categoryEn: string;
  categoryAr: string;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  URL_EN: string;
  URL_AR: string;
}

export const RESOURCES: ResourceItem[] = [
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Free Marketing Certificate',
    titleAr: 'شهادة التسويق المجانية',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Free+Marketing+Certificate+F1+-+Eng.docx/2aaa60e7-324a-15b1-0b82-0f1f83ad8f43?t=1763542597610',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9+%D8%A7%D9%84%D8%AA%D8%B3%D9%88%D9%8A%D9%82+%D8%A7%D9%84%D8%AD%D8%B1+1.docx/db33d9a1-9de6-965d-c94c-174ce69e3377?t=1763542671124',
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Owners - Partners Certificate',
    titleAr: 'شهادة بأن شخص شريك أو مالك',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Owner+Partner+Certificate+-+Eng.docx/58f3c2af-315f-8b6e-66d1-7506fe5d4d0e?t=1763527805328',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9+%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%83+%D8%A3%D9%88+%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%83%D9%8A%D9%86+%E2%80%93+%D8%A7%D9%84%D8%B4%D8%B1%D9%8A%D9%83+%D8%A3%D9%88+%D8%A7%D9%84%D8%B4%D8%B1%D9%83%D8%A7%D8%A1.docx/f02a4391-07a8-cd36-cd7b-7142936100fc?t=1763527817543'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'No Tax (Except VAT)',
    titleAr: 'شهادة عدم وجود نظام ضريبي (ما عدا ضريبة القيمة المضافة)',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/No+Tax+%28Except+VAT%29+-+Eng.docx/954a1419-bc3d-6ed5-a326-9c9c4a1eea29?t=1763527677050',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D9%84%D8%A7+%D8%B6%D8%B1%D8%A7%D8%A6%D8%A8+%E2%80%93.docx/fa9477f7-14c7-a7ce-aeca-6a5e586011a9?t=1763527690851'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Membership Registration Certificate',
    titleAr: 'شهادة توصية وتعريف (وضع الشركة)',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Membership+Registration+Certificate+-+Eng.docx/7da5f59d-7f39-85d9-5164-43479363e9d9?t=1763527577005',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9+%D8%AA%D8%B3%D8%AC%D9%8A%D9%84+%D8%B9%D8%B6%D9%88%D9%8A%D8%A9.docx/92dcc7b0-6f0a-5d29-5f62-1fd2bcaf03cb?t=1763527622273'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: "Company's Located Outside Free Zone",
    titleAr: 'شهادة بأن المنشأة تقع خارج المنطقة الحرة',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Confirmation+Of+Company%E2%80%99s+Location+%28OUTSIDE+FREE+ZONE%29+-+Eng.docx/48646f7b-20cf-00e0-7375-8bd66d460521?t=1763471545145',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%AA%D8%A3%D9%83%D9%8A%D8%AF+%D9%85%D9%88%D9%82%D8%B9+%D8%A7%D9%84%D8%B4%D8%B1%D9%83%D8%A9.docx/1f5bfd9a-4f9d-751d-5e42-bc6a5904eeb0?t=1763471760549'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'COO Issued by Dubai Chamber of Commerce',
    titleAr: 'شهادة منشأ صادرة عن غرفة تجارة دبي',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Confirmation+Of+Company%E2%80%99s+Location+%28OUTSIDE+FREE+ZONE%29+-+Eng.docx/48646f7b-20cf-00e0-7375-8bd66d460521?t=1763471545145',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9+%D8%A7%D9%84%D9%85%D9%86%D8%B4%D8%A3+%D8%B5%D8%A7%D8%AF%D8%B1%D8%A9+%D8%B9%D9%86+%D8%BA%D8%B1%D9%81%D8%A9+%D8%AF%D8%A8%D9%8A.docx/3a114f44-da76-f887-11e4-ab30bc83409a?t=1763471310925'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Authorized Signatory Certificate',
    titleAr: 'شهادة المخول بالتوقيع',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Authorized+Signatory+Certificate+-+Eng.docx/a45aad92-38c0-56b9-3f28-2870d60fa09a?t=1763469858752',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9+%D8%A7%D9%84%D9%85%D9%81%D9%88%D8%B6+%D8%A8%D8%A7%D9%84%D8%AA%D9%88%D9%82%D9%8A%D8%B9.docx/db9f8088-7525-31db-3c42-06d79c4e1423?t=1763470969139'
  },
  {
    categoryName: 'Service Manual',
    categoryEn: 'Service Manual',
    categoryAr: 'التقارير',
    titleEn: 'Service Manual',
    titleAr: 'دليل خدمات غرفة تجارة دبي',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Service_Manual_En.pdf/898401db-71e9-6523-f3c4-7c32732068da?t=1736843779637',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/Service_Manual_Ar.pdf/3c2651af-b1ca-fc04-e2eb-ab0f5df773c1?t=1736913758941'
  },
  {
    categoryName: 'Laws',
    categoryEn: 'Laws',
    categoryAr: 'القوانين',
    titleEn: 'Law No. (1) of 2022 on Establishing Dubai Chambers',
    titleAr: 'قانون رقم (1) لسنة 2022 بشأن إنشاء غرف دبي',
    descriptionEn: '',
    descriptionAr: 'تُنشأ بمُوجب هذا القانون ""غُرف دبي"" باعتبارها مُؤسّسة ذات نفع عام لا تهدف إلى تحقيق الربح، تتمتّع بالشخصيّة الاعتباريّة والاستقلال المالي والإداري، والأهليّة القانونيّة اللازمة لمُباشرة الأعمال والتصرُّفات التي تكفل تحقيق أهدافها.',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Law-No.-1-of-2022-on-Establishing-Dubai-Chambers.pdf/e92bdf80-2261-becd-e7d7-fdd1031470a2?t=1736227505958',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/Law-No.-1-of-2022-on-Establishing-Dubai-Chambers-Arabic.pdf/b04abba5-ec76-ccd4-4cbc-ec5f92ebe754?t=1736227784134'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Authorisation Letter',
    titleAr: 'رسالة تفويض',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Authorisation+letter.docx/e4c40636-2e68-6eae-c19e-4a542850b852?t=1738209994636',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/Authorisation+letter+-+AR.docx/a04e87ad-d880-72bc-45ad-a4f52f8af001?t=1738210024390'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Letter of Pledged Commitment',
    titleAr: 'رسالة تعهد والتزام',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/1416528/Letter+of+pledged+commitment+-+EN.docx/cfa6d4a1-c191-c47f-ed83-bae1e72dd93e?t=1738210135541',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/1416528/Letter+of+pledged+commitment+-+AR.docx/c76b893b-67c2-251c-a2ad-569b3dbab1f9?t=1738210153773'
  },
  {
    categoryName: 'Reports',
    categoryEn: 'Reports',
    categoryAr: 'التقارير',
    titleEn: 'Customer Happiness Charter',
    titleAr: 'ميثاق سعادة المتعاملين',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Customer_happiness-charter_EN.pdf/f890cf5a-d681-182f-970e-765b41439317?t=1724832443193',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Customer_happiness_charter_AR.pdf/15274dec-829c-aea2-68ff-86a66f788ee0?t=1729704793823'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Used vehicle bought from the local market',
    titleAr: 'سيارة مستعملة تم شراؤها من السوق المحلي',
    descriptionEn:
      'The form is used by a resident who intends to export their personal vehicles to their home country.',
    descriptionAr: 'يُستخدم هذا النموذج من قبل المُقيم في الدولة ويرغب بتصدير سياراته الشخصية إلى وطنه.',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/used_vehicle_bought_from_the_local_market_2021.pdf/7fc13829-4cd5-eaa6-b574-8f7c8e2bbc2d?t=1723020427066',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/used_vehicle_bought_from_the_local_market_2021.pdf/7fc13829-4cd5-eaa6-b574-8f7c8e2bbc2d?t=1723020427066',
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Animal Export Form',
    titleAr: 'نموذج تصدير حيوانات',
    descriptionEn:
      'This form is used by owners of animals and pets who intend to export them abroad.',
    descriptionAr:
      'يَستخدم هذا النموذج من يمتلك حيوانات وحيوانات أليفة ويرغب بتصديرها إلى الخارج.',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Animal_Export_Form_2021.pdf/50e884ff-41a6-1a6b-aba4-fa4104cea93e?t=1723026022922',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Animal_Export_Form_2021.pdf/50e884ff-41a6-1a6b-aba4-fa4104cea93e?t=1723026022922'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Used personal effects bought from local market',
    titleAr: 'متعلقات شخصية مستعملة تم شراؤها من السوق المحلي',
    descriptionEn:
      'This form is used for residents moving their personal effects to their home country.',
    descriptionAr:
      'يُستخدم هذا النموذج للمُقيم الذي يرغب بنقل أمتعته الشخصية إلى وطنه.',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/used_personal_effects_bought_from_local_market_2021+%282%29.pdf/63bbabe3-843f-250f-3dc2-1f731ed05193?t=1723025915260',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/used_personal_effects_bought_from_local_market_2021+%281%29.pdf/c9a4fc42-7d50-7898-8f01-a23c1e74a112?t=1723025893069'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Attestation Information',
    titleAr: 'معلومات حول التصديقات التجارية',
    descriptionEn: '',
    descriptionAr: 'نموذج للوثائق المصدقة وغير المصدقة من قبل غرفة تجارة دبي.',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/General_Information_Attestation.pdf/a7746ea3-2cf6-cd11-11e2-d9dd0908c70a?t=1723026187937',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/General_Information_Attestation.pdf/a7746ea3-2cf6-cd11-11e2-d9dd0908c70a?t=1723026187937'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'Authorised Signatory Card',
    titleAr: 'بطاقة المخولين بالتوقيع',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Signature_Card_2023.pdf/965f4095-5d75-2a52-1d29-bc667b6b283f?t=1723026415867',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Signature_Card_2023.pdf/965f4095-5d75-2a52-1d29-bc667b6b283f?t=1723026415867'
  },
  {
    categoryName: 'Forms & Guidelines',
    categoryEn: 'Forms & Guidelines',
    categoryAr: 'نماذج وإرشادات',
    titleEn: 'HS Code',
    titleAr: 'رمز النظام المنسق (HS Code)',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/customs_tariff_en.pdf/06bcc37b-9952-ff2f-5647-e8b6856ce87c?t=1723026532786',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/customs_tariff_ar.pdf/d3c251b9-6c86-0f4a-e970-44475fe47aeb?t=1730138609876'
  },
  {
    categoryName: 'Commerce',
    categoryEn: 'Commerce',
    categoryAr: 'التجارة',
    titleEn: 'Export Products Free Marketing (Free Sale Certificate) – F1',
    titleAr: 'تسويق المنتجات للتصدير (شهادة البيع الحر) – F1',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Export-Products-Free-Marketing-Free-Sale-Certificate-F1.docx/e27298aa-e3d9-42d6-d238-5ccfe977fae7?t=1723027686664',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Export-Products-Free-Marketing-Free-Sale-Certificate-F1.docx/e27298aa-e3d9-42d6-d238-5ccfe977fae7?t=1723027686664',
  },
  {
    categoryName: 'Commerce',
    categoryEn: 'Commerce',
    categoryAr: 'التجارة',
    titleEn: 'Export Products Free Marketing (Free Sale Certificate) – F2',
    titleAr: 'تسويق المنتجات للتصدير (شهادة البيع الحر) – F2',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Export+products++Free+Marketing+%28free+sale+Certificate%29-+F2.docx/5cbb6a67-571d-7a45-8805-8dd339a91504?t=1730134320195',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Export+products++Free+Marketing+%28free+sale+Certificate%29-+F2.docx/5cbb6a67-571d-7a45-8805-8dd339a91504?t=1730134320195',
  },
  {
    categoryName: 'Commerce',
    categoryEn: 'Commerce',
    categoryAr: 'التجارة',
    titleEn: 'Company Profile',
    titleAr: 'بيانات منشأة',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Company+Profile.docx/eeb5a842-66b6-0826-a7bb-8e41eda6f954?t=1730099221559',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/%D8%A8%D9%8A%D8%A7%D9%86%D8%A7%D8%AA+%D9%85%D9%86%D8%B4%D8%A3%D8%A9.docx/bbbee8d0-fea7-b3ea-8ce0-8f6b58b16757?t=1730101258799'
  },
  {
    categoryName: 'Commerce',
    categoryEn: 'Commerce',
    categoryAr: 'التجارة',
    titleEn: 'Tax Reclaim',
    titleAr: 'شهادة عدم وجود نظام ضريبي بالإمارات ( ما عدا ضريبة القيمة المضافة)',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Tax-Reclaim.docx/4400ca78-fe71-7219-218c-ccda335da168?t=1723030038056',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Tax+Reclaim+Arabic.docx/068d6c35-a776-1f9d-4981-ed8f59b6654a?t=1730133432055'
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2024',
    titleAr: 'التقرير السنوي 2024',
    descriptionEn: 'A Cycle of Growth & Economic Impact',
    descriptionAr: 'مسار النمو والأثر الاقتصادي',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/DC-Annual-Report-2024-EN.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/DC-Annual-Report-2024-AR.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2023',
    titleAr: 'التقرير السنوي 2023',
    descriptionEn: 'Unlocking Dubai’s Growth Ambitions',
    descriptionAr: 'طموح يعانق الإنجازات',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Annual_Report_2023_English.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Annual_Report_2023_Arabic.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2022',
    titleAr: 'التقرير السنوي 2022',
    descriptionEn: 'Preparing Dubai for the Future',
    descriptionAr: 'صناعة المستقبل في دبي',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Dubai-Chambers-Annual-Report-2022-LQ-3.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Dubai_Chambers_AnnualReport_2022_Arabic.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2021',
    titleAr: 'التقرير السنوي 2021',
    descriptionEn: 'A Bolder Vision',
    descriptionAr: 'دبي : معادلة الابتكار لاقتصاد الغد',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/annual_report_2021_english.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/annual_report_2021_arabic.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2020',
    titleAr: 'التقرير السنوي 2020',
    descriptionEn: 'The Dubai Normal and The Future of Business',
    descriptionAr: 'اقتصاد المستقبل : معادلة دبي الناجحة للتعافي الاقتصادي',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/annual_report_2020_english.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/annual_report_2020_arabic.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2019',
    titleAr: 'التقرير السنوي 2019',
    descriptionEn: 'The World in Dubai',
    descriptionAr: 'دبي تحتفي بالعالم',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/Annual-report-2019.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/Annual-report-2019.pdf',
  },
  {
    categoryName: 'Annual Reports',
    categoryEn: 'Annual Reports',
    categoryAr: 'التقارير السنوية',
    titleEn: 'Annual Report 2018',
    titleAr: 'التقرير السنوي 2018',
    descriptionEn: 'Growth Beyond Borders',
    descriptionAr: 'نمو يتخطى الحدود',
    URL_EN: 'https://www.dubaichambers.com/documents/20119/0/DC_Annual_Report_2018.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/20119/0/DC_Annual+Report_2018_AR.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Dubai Startup Guide',
    titleAr: 'دليل الشركات الناشئة في دبي',
    descriptionEn: 'Guide to starting up in Dubai’s digital ecosystem',
    descriptionAr: 'دليل لبدء الأعمال في نظام دبي الرقمي',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: '',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Scaling From Dubai',
    titleAr: 'التوسع من دبي',
    descriptionEn: 'Success rates and the available environment',
    descriptionAr: 'معدلات النجاح والبيئة المتاحة',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Building your Business in a Dynamic City: The Entrepreneur’s Guide 2023',
    titleAr: 'بناء عملك في مدينة ديناميكية: دليل رواد الأعمال 2023',
    descriptionEn: 'Valuable guidance for entrepreneurs',
    descriptionAr: 'إرشادات قيمة لرواد الأعمال',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Dubai’s Venture Capital Ecosystem',
    titleAr: 'نظام رأس المال المخاطر في دبي',
    descriptionEn: 'Exploring the startup investor landscape',
    descriptionAr: 'استكشاف بيئة المستثمرين في الشركات الناشئة',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Dubai’s Digital Economy and its Expanding Startup Ecosystem',
    titleAr: 'الاقتصاد الرقمي في دبي ونظام الشركات الناشئة المتوسع',
    descriptionEn: 'Why Dubai is positioned to lead the digital economy',
    descriptionAr: 'لماذا تتمتع دبي بموقع قيادي في الاقتصاد الرقمي',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'Dubai’s roadmap to becoming the Digital Economy Capital of the World',
    titleAr: 'خارطة طريق دبي لتصبح عاصمة الاقتصاد الرقمي في العالم',
    descriptionEn: 'Overview of digital economy ambitions',
    descriptionAr: 'نظرة عامة على طموحات الاقتصاد الرقمي',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'The Impact of Hyperscale Cloud',
    titleAr: 'تأثير السحابة عالية النطاق',
    descriptionEn: 'Why robust digital infrastructure is critical',
    descriptionAr: 'لماذا البنية التحتية الرقمية القوية أمر حاسم',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'DUBAI STARTUP OUTLOOK 2021',
    titleAr: 'توقعات الشركات الناشئة في دبي 2021',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'HELPING STARTUPS ACCESS FUNDING',
    titleAr: 'مساعدة الشركات الناشئة في الوصول إلى التمويل',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'OPENING A BANK ACCOUNT',
    titleAr: 'فتح حساب بنكي',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 01 / 2018',
    titleAr: 'بانوراما الشركات الناشئة – العدد 01 / 2018',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 02 / 2018',
    titleAr: 'بانوراما الشركات الناشئة – العدد 02 / 2018',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 03 / 2018',
    titleAr: 'بانوراما الشركات الناشئة – العدد 03 / 2018',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 04 / 2018',
    titleAr: 'بانوراما الشركات الناشئة – العدد 04 / 2018',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 05 / 2019',
    titleAr: 'بانوراما الشركات الناشئة – العدد 05 / 2019',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 06 / 2019',
    titleAr: 'بانوراما الشركات الناشئة – العدد 06 / 2019',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 07 / 2019',
    titleAr: 'بانوراما الشركات الناشئة – العدد 07 / 2019',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 08 / 2020',
    titleAr: 'بانوراما الشركات الناشئة – العدد 08 / 2020',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 09 / 2020',
    titleAr: 'بانوراما الشركات الناشئة – العدد 09 / 2020',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 10 / 2020',
    titleAr: 'بانوراما الشركات الناشئة – العدد 10 / 2020',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 11 / 2020',
    titleAr: 'بانوراما الشركات الناشئة – العدد 11 / 2020',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'STARTUP PANORAMA – Edition 12 / 2021',
    titleAr: 'بانوراما الشركات الناشئة – العدد 12 / 2021',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'THE BIG PICTURE – 2021',
    titleAr: 'الصورة الأوسع – 2021',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'UAE VENTURE OUTLOOK 2022',
    titleAr: 'آفاق المشاريع في الإمارات 2022',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  },
  {
    categoryName: 'Knowledge Hub',
    categoryEn: 'Knowledge Hub',
    categoryAr: 'مركز المعرفة',
    titleEn: 'VALIDATING STARTUP BUSINESS IDEA',
    titleAr: 'التحقق من فكرة مشروع ناشئ',
    descriptionEn: '',
    descriptionAr: '',
    URL_EN: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
    URL_AR: 'https://www.dubaichambers.com/documents/184026/0/Dubai+Startup+Guide+2025.pdf',
  }
];

